import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import * as signalR from '@microsoft/signalr';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class OffboardingSignalRService implements OnDestroy {
  private hubConnection: signalR.HubConnection | null = null;
  private started = false;

  // Events that components can subscribe to
  readonly recordCreated$ = new Subject<any>();
  readonly tasksUpdated$ = new Subject<any>();
  readonly statusChanged$ = new Subject<any>();
  readonly questionnaireSubmitted$ = new Subject<any>();

  start(): void {
    if (this.started) return;

    const hubUrl = environment.apiUrl.replace('/api', '/hubs/offboarding');

    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(hubUrl)
      .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
      .build();

    this.hubConnection.on('OffboardingRecordCreated', (data) => this.recordCreated$.next(data));
    this.hubConnection.on('OffboardingTasksUpdated', (data) => this.tasksUpdated$.next(data));
    this.hubConnection.on('OffboardingStatusChanged', (data) => this.statusChanged$.next(data));
    this.hubConnection.on('QuestionnaireSubmitted', (data) => this.questionnaireSubmitted$.next(data));

    this.hubConnection
      .start()
      .then(() => { this.started = true; })
      .catch(() => { this.started = false; });
  }

  stop(): void {
    if (this.hubConnection) {
      this.hubConnection.stop();
      this.started = false;
    }
  }

  ngOnDestroy(): void {
    this.stop();
  }
}
